import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
    claimReference: string;
};

const WithdrawnClaimApplicationBody = (props: Props) => {
    const { claimReference } = props;
    const { t } = useTranslation();
    return (
        <div className="row">
            <div className="col-sm-12">
                {t<string>('withdrawClaimApplicationSuccess').replace(
                    t<string>('claimReferenceCode'),
                    claimReference,
                )}
            </div>
        </div>
    );
};

export default WithdrawnClaimApplicationBody;
